'use strict'

const INSTRUMENT_CONN_STATUS_REQUEST= "INSTRUMENT_CONN_STATUS_REQUEST";
const INSTRUMENT_CONN_STATUS_SUCCESS= "INSTRUMENT_CONN_STATUS_SUCCESS";
const INSTRUMENT_CONN_STATUS_FAILURE= "INSTRUMENT_CONN_STATUS_FAILURE";
const INSTRUMENT_CONN_DEVICE_STATE_ADD = 'INSTRUMENT_CONN_DEVICE_STATE_ADD';
const INSTRUMENT_CONN_DEVICE_STATE_REMOVE = 'INSTRUMENT_CONN_DEVICE_STATE_REMOVE';

export {
    INSTRUMENT_CONN_STATUS_REQUEST,
	INSTRUMENT_CONN_STATUS_SUCCESS,
	INSTRUMENT_CONN_STATUS_FAILURE,
	INSTRUMENT_CONN_DEVICE_STATE_ADD,
	INSTRUMENT_CONN_DEVICE_STATE_REMOVE
}